export default __webpack_public_path__ + "static/media/ReportXLS.5b9d9c89.svg";